// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7817":"css/app.7028","9175":"css/admin-app.7028"}[chunkId] + ".css";
};